import { createComponent, createHook } from 'reakit-system';
import { BoxHTMLProps, BoxOptions, useBox } from '../../Box/Box';
import { WHCM, WHCMstyles } from '../../constants';
import pxToRem from '../../utils/pxToRem';

export const useProgressBar = createHook<BoxOptions, BoxHTMLProps>({
  name: 'ProgressBar',
  compose: [useBox],
  useOptions(options) {
    return {
      ...options,
      styles: {
        pt: 'sp-8',
        bg: 'progressBarValue',
        borderRadius: pxToRem(8),
        [WHCM]: {
          ...WHCMstyles,
          backgroundColor: 'Highlight',
        },
      },
    };
  },
});
export const ProgressBarField = createComponent({
  as: 'div',
  useHook: useProgressBar,
  memo: true,
});
